import { createSelector } from "@reduxjs/toolkit";
import { Message } from "../types";
import { selectReplyMessageId } from "./select-reply-message-id";
import { selectChatMessages } from "./select-chat-messages";

export const selectReplyMessage = createSelector(
  selectReplyMessageId,
  selectChatMessages,
  (replyMessageId: string, messages: Message[]) =>
    messages.find(
      (message) => replyMessageId && message.id === replyMessageId
    ) ?? null
);
